
export type TemplateRole = {
  id: string;
  name: string;
  description?: string;
}